import * as R from 'ramda';


/**
 * Classifies a collection of uniform objects.
 *
 * @param  {array} taxonomy - Array of keys to recursively group objects by.
 *   Each value in the array can be either:
 *   - string: Key in each object, the value of which will be used to classify
 *     the object.
 *   - function: Invoked with each object in the collection, the return value
 *     will be used to classify the object.
 * @param  {array} collection - The collection to classify.
 * @return {object}
 */
function classify(taxonomy, collection) {
  if (taxonomy.length) {
    const generateKey = item => {
      // Current tier is the first item in the taxonomy.
      const tier = R.head(taxonomy);

      if (typeof tier === 'string') {
        // Use the value of the key for grouping.
        return R.prop(tier, item);
      } else {
        // Use a custom function for grouping.
        return tier(item);
      }
    };

    return R.map(members => {
      return classify(R.tail(taxonomy), members);
    }, R.groupBy(generateKey, collection));
  } else {
    return collection;
  }
}


export default classify;



// WEBPACK FOOTER //
// ./src/lib/classify.js